import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductGroupFactors({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_PRODUCT_GROUP_FACTORS_REQUEST')

        return axios
            .get(`/finances/margins${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCT_GROUP_FACTORS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCT_GROUP_FACTORS_FAILURE')
                handleApiError(error, 'Pobranie współczynników grupy produktowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductGroupFactor({ commit }, payload) {
        return axios
            .put(`/finances/margins/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Współczynnik grupy produktowej został zaktualizowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja współczynnika grupy produktowej nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setProductGroupFactorsFilters({ commit }, filters) {
        commit('SET_PRODUCTS_GROUP_FACTORS_FILTERS', filters)
    },
    clearProductGroupFactorsFilters({ commit }) {
        commit('CLEAR_PRODUCTS_GROUP_FACTORS_FILTERS')
    }
}